import React, { Component } from "react";
import "./Sokrim.scss";
export default class Sokrim extends Component {
    render() {
        return (
            <section className="section section-sokrim">
                <div className="padding">
                    <div className="container">
                        <iframe src="https://z.ynet.co.il/mShort/content/ElectionsPolls/"
                            frameBorder="0" scrolling="no"></iframe>
                    </div>
                </div>
            </section>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Components/Sokrim/Sokrim.jsx